<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Recupera password</h1>
      </div>
      <p class="editor-lead">Verrà inviata un'email all'indirizzo inserito, con il link per reimpostare la password.</p>
    </header>

    <form class="editor-form" [formGroup]="recoverPswForm">
      <section class="editor-panel">
        <h2>Email</h2>
        <div class="field-block">
          <label for="email">Indirizzo email<sup>*</sup></label>
          <input id="email" class="field" type="email" formControlName="email" autocomplete="email"
            (input)="checkEmail()"
            [class.is-invalid]="recoverPswForm.invalid && (recoverPswForm.dirty || recoverPswForm.touched)">
          @if (!validEmail) {
            <p class="field-error">Email non valida.</p>
          }
        </div>
      </section>

      <div class="editor-actions">
        <button class="editor-save" type="button" (click)="send()" [disabled]="recoverPswForm.invalid">
          Invia
        </button>
      </div>
    </form>
  </div>
</div>
